<template>
  <div class="my-purchase">
    <PurchasePage 
      ref="purchasePage"
      :tabs="tabs"
      :show-total-count="true"
      :total-count-label="'总采购单数'"
      :show-time-filter="true"
      :search-fields="searchFields"
      :time-filter-tabs="timeFilterTabs"
      :columns="columns"
      :show-expand="true"
      :expand-columns="expandColumns"
      :show-operation="true"
      :operation-width="'150'"
      :query="getMockData"
      :status-map="statusMap"
      @tab-change="handleTabChange"
      @view="handleView"
      @cancel="handleCancel"
      @product-action="handleProductAction"
    >
      <!-- 询价单号 -->
      <template #orderNo="{ row }">
        <el-link type="primary" :underline="false" @click.stop="handleInquiryView(row)">
          {{ row.orderNo || '-' }}
        </el-link>
      </template>

      <!-- 自定义展开行的商品信息列 -->
      <template #expand-productInfo="{ row }">
        <div class="product-info">
          <div class="product-detail">
            <div class="product-header">
              <div class="brand-label">品牌名</div>
              <div class="product-name">{{ row.productName }}</div>
            </div>
            <div class="product-row">
              <span class="product-label">型号：</span>
              <span class="product-value">{{ row.model }}</span>
              <span class="product-label" style="margin-left: 40px;">订货号：</span>
              <span class="product-value">{{ row.orderNo }}</span>
            </div>
            <div class="product-row">
              <span class="product-label">包装规格：</span>
              <span class="product-value">{{ row.packaging }}</span>
              <span class="product-label" style="margin-left: 40px;">面价：</span>
              <span class="product-value">¥490</span>
            </div>
          </div>
        </div>
      </template>
      
      <!-- 自定义展开行的参数列 -->
      <template #expand-params="{ row }">
        <div class="params">
          <div v-for="(value, key) in row.parameters" :key="key">
            {{ key }}：{{ value }}
          </div>
          <div v-if="!row.parameters || Object.keys(row.parameters).length === 0">
            暂无参数
          </div>
        </div>
      </template>
      
      <!-- 自定义展开行的渠道列 -->
      <template #expand-channel="{ row }">
        <div class="channel">
          <span :class="['channel-tag', `channel-${row.channelText}`]">
            {{ row.channelText }}
          </span>
        </div>
      </template>
      
      <!-- 自定义展开行的价格列 -->
      <template #expand-price="{ row }">
        <div class="price">￥ 35</div>
      </template>
      
      <!-- 自定义展开行的数量列 -->
      <template #expand-quantity="{ row }">
        <div>{{ row.quantity }}个</div>
      </template>
      
      <!-- 自定义展开行的总计列 -->
      <template #expand-total="{ row }">
        <div class="total">
          <div>已付￥{{ row.paidAmount }}</div>
          <div>运费：￥{{ row.deliveryFee }}</div>
          <div>支付方式：{{ row.paymentMethod }}</div>
        </div>
      </template>
      
      <!-- 自定义展开行的状态列 -->
      <template #expand-status="{ row }">
        <div class="status">
          <div>{{ row.supplierStatus }}</div>
          <div>{{ row.buyerStatus }}</div>
          <div>{{ row.paymentStatus }}</div>
          <div>{{ row.deliveryStatus }}</div>
        </div>
      </template>
      
      <!-- 自定义展开行的操作列 -->
      <template #expand-actions="{ row }">
        <div class="actions">
          <el-button type="primary" size="small" round @click="handleProductActionClick(row, 'confirm')">
            确认收货
          </el-button>
          <el-button type="text" @click="handleProductActionClick(row, 'reorder')">
            再次下单
          </el-button>
          <el-button type="text" @click="handleProductActionClick(row, 'detail')">
            查看详情
          </el-button>
        </div>
      </template>
      
      <!-- 自定义主表格操作列 -->
      <template #operation="{ row }">
        <el-button type="text" @click="handleView(row)">查看</el-button>
        <el-button type="text" @click="handleCancel(row)">作废</el-button>
      </template>
    </PurchasePage>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus';
import PurchasePage from '@/components/publicComponent/purchasePage';
import request from '@/common/js/request.js';

export default {
  name: 'MyPurchase',
  components: {
    PurchasePage
  },
  data() {
    return {
      tabs: [
        { label: '全部订单', value: 'ALL' },
        { label: '待发合同', value: 'WAIT_CONTRACT' },
        { label: '已上传合同', value: 'UPLOADED_CONTRACT' },
        { label: '已回传合同', value: 'BACK_CONTRACT' },
        { label: '待付款', value: 'WAIT_PAY' },
        { label: '部分付款', value: 'PARTIAL_PAY' },
        { label: '已付款', value: 'PAID' },
        { label: '待发货', value: 'WAIT_SHIP' },
        { label: '部分发货', value: 'PARTIAL_SHIP' },
        { label: '已发货', value: 'SHIPPED' },
        { label: '已收货', value: 'RECEIVED' },
        { label: '待开发票', value: 'WAIT_INVOICE' },
        { label: '已开发票', value: 'INVOICED' },
        { label: '已完成', value: 'COMPLETED' },
        { label: '已取消', value: 'CANCELLED' },
      ],
      searchFields: [
        { prop: 'wd', type: 'input', label: '综合搜索', width: '280px' },
        { prop: 'documentNumber', type: 'input', label: '采购订单', placeholder: '请输入采购订单号', width: '180px' },
        { prop: 'brandName', type: 'input', label: '品牌', placeholder: '请输入品牌名称', width: '180px' },
        { prop: 'startDate', type: 'date', label: '下单时间', placeholder: '2025-10', width: '140px' },
        { prop: 'endDate', type: 'date', label: '至', placeholder: '2025-10', width: '140px' },
      ],
      timeFilterTabs: [
        { label: '今天', value: 'today' },
        { label: '本周', value: 'week' },
        { label: '本月', value: 'month' },
      ],
      columns: [
        { prop: 'documentTime', label: '制单时间', width: '150' },
        { prop: 'orderNo', label: '询价单号', width: '150' },
        { prop: 'purchaseNo', label: '采购单号', width: '150' },
        { prop: 'productName', label: '采购品牌', minWidth: '200' },
        { prop: 'supplierName', label: '采购状态', width: '180' },
        { prop: 'buyerName', label: '供应商公司名称', width: '180' },
        { prop: 'supplierContact', label: '供应商联系人', width: '120' },
        { prop: 'buyerContact', label: '采购方联系人', width: '120' },
        { prop: 'buyerPublicAccount', label: '供应商手机号', width: '150' },
        { prop: 'supplierPublicAccount', label: '客户公司名称', width: '150' },
        { prop: 'finalUser', label: '最终用户', width: '120' },
        { prop: 'projectName', label: '付款金额', width: '120' }
      ],
      expandColumns: [
        { prop: 'productInfo', label: '商品信息', minWidth: '160' },
        { prop: 'params', label: '参数', },
        { prop: 'channel', label: '渠道',  align: 'center' },
        { prop: 'price', label: '促销价', align: 'center' },
        { prop: 'quantity', label: '数量',align: 'center' },
        { prop: 'total', label: '总计',  },
        { prop: 'status', label: '订单状态',  },
        { prop: 'actions', label: '操作',width: '120',  align: 'center', fixed: 'right' }
      ],
      statusMap: {
        ALL: '',
        WAIT_CONTRACT: 'WAIT_CONTRACT',
        UPLOADED_CONTRACT: 'UPLOADED_CONTRACT',
        BACK_CONTRACT: 'BACK_CONTRACT',
        WAIT_PAY: 'WAIT_PAY',
        PARTIAL_PAY: 'PARTIAL_PAY',
        PAID: 'PAID',
        WAIT_SHIP: 'WAIT_SHIP',
        PARTIAL_SHIP: 'PARTIAL_SHIP',
        SHIPPED: 'SHIPPED',
        RECEIVED: 'RECEIVED',
        WAIT_INVOICE: 'WAIT_INVOICE',
        INVOICED: 'INVOICED',
        COMPLETED: 'COMPLETED',
        CANCELLED: 'CANCELLED',
      }
    };
  },
  methods: {
    ...mapActions('purchaseMudule', [
      'purchasePageBuyer',
      'purchaseUndo',
    ]),
    ...mapMutations('purchaseMudule', ['renewTurnInquiryInfo']),
    // 查询采购单列表
    async getMockData(params) {
      try {
        const response = await request.post('/purchase/page/enhanced', {
          pageNo: params.pageNo || 1,
          pageSize: params.pageSize || 10,
          statusTag: params.statusTag || '',
          startDate: params.startDate || '',
          endDate: params.endDate || '',
          wd: params.wd || '',
          type: '0', // 采购单
          ...params
          
        });

        if (response.data.code === '0') {
          const { rows = [], totalCount = 0 } = response.data.data || {};
          
          // 转换数据格式以适配表格展示
          const formattedRows = rows.map(item => ({
            id: item.documentId,
            documentTime: item.documentDate,
            orderNo: item.inquiryNo,
            purchaseNo: item.documentNumber,
            productName: item.purchaseBrands,
            supplierName: item.sellerEnterpriseName,
            buyerName: item.buyerEnterpriseName,
            supplierContact: item.sellerName,
            buyerContact: item.buyerName,
            buyerPublicAccount: item.buyerPhone,
            supplierPublicAccount: item.sellerEnterpriseName,
            finalUser: item.inquiryCustomerName || '-',
            projectName: item.purchaseAmt ? `¥${item.purchaseAmt}` : '¥0',
            documentStatus: item.lastStatusLabel,
            inquiryId: item.inquiryId,
            // 商品明细列表
            products: (item.itemDetailList || []).map(product => {
              return {
                productName: product.productName,
                model: product.barCode,
                orderNo: product.articleNo,
                packaging: product.packageSpec || '-',
                unit: '个',
                channel: product.channel,
                channelText: product.channelLabel,
                parameters: product.parameters || {}, // 直接使用接口返回的parameters
                priceType: '促销',
                supplyPrice: product.promotionPrice || product.purchasePrice,
                quantity: product.purchaseQty,
                paidAmount: item.paidAmount || '0.00',
                deliveryFee: '0.00',
                paymentMethod: item.paymentMethod || '-',
                supplierStatus: this.getContractStatusText(item.contractStatus),
                buyerStatus: this.getPaymentStatusText(item.isPay),
                paymentStatus: this.getReceivingStatusText(item.receivingStatus),
                deliveryStatus: this.getShipStatusText(item.shipStatus),
                skuId: product.skuId,
                documentItemId: product.documentItemId,
                totalAmount: product.totalAmount,
                documentId: item.documentId, // 保存采购单ID用于确认收货
              };
            })
          }));

          return {
            data: {
              code: '0',
              data: {
                rows: formattedRows,
                totalCount
              }
            }
          };
        }
        
        return response;
      } catch (error) {
        console.error('查询采购单列表失败:', error);
        ElMessage.error('查询失败，请稍后重试');
        return {
          data: {
            code: '-1',
            data: {
              rows: [],
              totalCount: 0
            }
          }
        };
      }
    },
    // 合同状态转换
    getContractStatusText(status) {
      const statusMap = {
        '0': '待上传合同',
        '1': '待回传合同',
        '2': '已回传合同'
      };
      return statusMap[status] || '-';
    },
    // 支付状态转换
    getPaymentStatusText(status) {
      const statusMap = {
        '0': '未支付',
        '1': '全部支付',
        '2': '部分支付'
      };
      return statusMap[status] || '-';
    },
    // 收货状态转换
    getReceivingStatusText(status) {
      const statusMap = {
        'NIL': '未收货',
        'PD': '部分收货',
        'AD': '全部收货'
      };
      return statusMap[status] || '-';
    },
    // 发货状态转换
    getShipStatusText(status) {
      const statusMap = {
        'NIL': '未发货',
        'PD': '部分发货',
        'AD': '全部发货'
      };
      return statusMap[status] || '-';
    },
    handleTabChange(tab) {
      console.log('Tab changed:', tab);
    },
    handleInquiryView(row) {
      if (!row.inquiryId) {
        ElMessage.warning('询价单ID为空，无法查看询价详情');
        return;
      }
      this.$router.push({
        path: '/purchase/enquiryDetails',
        query: {
          id: row.inquiryId
        }
      });
    },
    handleView(row) {
      this.$router.push({
        path: "/mysale/xinOrderDetails",
        query: {
          id: row.id, //订单id
          inquiryId: row.inquiryId, //询价单id
          type:'_purchase',
        },
      });
    },
    handleCancel(row) {
      this.purchaseUndo(row.id).then(res => {
        if (res && res.status == 200) {
          ElMessage.success('作废成功');
          this.refresh();
        } else {
          ElMessage.error('作废失败');
        }
      }).catch(err => {
        ElMessage.error('作废失败');
      });
    },
    handleProductAction({ orderRow, productRow, action }) {
      const actionMap = {
        confirm: '确认收货',
        reorder: '再次下单',
        detail: '查看详情'
      };
      console.log('操作', actionMap[action], orderRow, productRow);
      ElMessage.success(`${actionMap[action]}功能开发中`);
    },
    handleProductActionClick(row, action) {
      if (action === 'reorder') {
        // 再次下单 - 跳转到添加询价页面
        this.turnInquiry(row);
      } else if (action === 'confirm') {
        // 确认收货
        this.confirmReceipt(row);
      } else if (action === 'detail') {
        ElMessage.success('查看详情功能开发中');
      }
    },
    // 确认收货
    confirmReceipt(row) {
      ElMessageBox.prompt('请输入收货备注（可选）', '确认收货', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputType: 'textarea',
      }).then(({ value }) => {
        request.post('/purchase/receipt', {
          documentId: row.documentId,
          receiptRemarks: value || '',
          shipId: row.shipId || '', // shipId可选
        }).then(res => {
          if (res.data.code === '0') {
            ElMessage.success('确认收货成功');
            this.refresh();
          } else {
            ElMessage.error(res.data.msg || '确认收货失败');
          }
        }).catch(err => {
          ElMessage.error('确认收货失败');
        });
      }).catch(() => {
        // 取消操作
      });
    },
    // 再次下单 - 转成我的询价
    turnInquiry(row) {
      // 构造询价信息，参考editOfferInfo.vue的turnInquiry方法
      const info = {
        inquiryRequestVO: {
          id: row.inquiryId,
          buyerEnterpriseId: row.buyerEnterpriseId,
          buyerId: row.buyerId,
        },
        itemRequestVOList: [row] // 将当前商品作为询价商品
      };
      this.renewTurnInquiryInfo(info);
      this.$router.push({
        path: "/purchase/addInquiryPage",
      });
    },
    refresh() {
      this.$refs.purchasePage?.refresh();
    }
  }
};
</script>

<style scoped lang="less">
.my-purchase {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
</style>

<style scoped lang="less">
.my-purchase {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  
  .product-info {
    display: flex;
    gap: 10px;
    padding: 10px 0;
    
    .product-detail {
      flex: 1;
      
      .product-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
        
        .brand-label {
          padding: 2px 12px;
          border: 1px solid #48A09C;
          border-radius: 3px;
          color: #48A09C;
          font-size: 12px;
          white-space: nowrap;
        }
        
        .product-name {
          font-weight: 500;
          font-size: 14px;
          color: #303133;
        }
      }
      
      .product-row {
        font-size: 12px;
        color: #909399;
        margin-top: 6px;
        line-height: 1.5;
        
        .product-label {
          color: #909399;
        }
        
        .product-value {
          color: #606266;
        }
      }
    }
  }
  
  .params {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    color: #606266;
  }
  
  .channel {
    display: flex;
    justify-content: center;
    
    .channel-tag {
      padding: 4px 16px;
      border-radius: 20px;
      font-size: 13px;
      border: 1px solid;
      display: inline-block;
      
      &.channel-代理 {
        color: #E6A23C;
        border-color: #E6A23C;
        background: #FFF;
      }
      
      &.channel-自营 {
        color: #409EFF;
        border-color: #409EFF;
        background: #FFF;
      }
      
      &.channel-厂家 {
        color: #9B59B6;
        border-color: #9B59B6;
        background: #FFF;
      }
    }
  }
  
  .price {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    color: #F56C6C;
  }
  
  .total,
  .status {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    color: #606266;
  }
  
  .actions {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
}
</style>
